(function() {
	
	var Container = include("PIXI.Container"),
		Texture = include("PIXI.Texture"),
		Sprite = include("PIXI.Sprite"),
		Application = include("springroll.Application");
		
	var SuspectPanel = function()
	{
		Container.call(this);
		
		this.background = null;
		this.levelContainer = null;
	};
	
	var p = SuspectPanel.prototype = Object.create(Container.prototype);
	
	p.setup = function()
	{
		this.background = new Sprite(Texture.fromImage("suspect_bg"));
		this.addChild(this.background);
		
		this.levelContainer = new Container();
		this.addChild(this.levelContainer);
	};
	
	p.teardown = function()
	{
		if(!this.levelContainer) return;
		
		this.removeChildren();
		this.background.destroy();
		this.levelContainer.destroy();
		this.background = this.levelContainer = null;
	};
	
	namespace('heist').SuspectPanel = SuspectPanel;
}());